import styled from "styled-components"

export const Container = styled.input`
    height: 50px;
    width: 100%;
    padding: 8px 15px;
    border-radius: 3px;
    color: var(--primary);
    letter-spacing: 0.1px;
    font-size: 0.938rem;
    margin: 0;
    outline: none;
    border-color: var(--blue);
    border: 1px solid var(--shade);
    resize: none;
`